import type { FaireProductEntity } from "../../entity_types/product";

export const p_8uquc4add9: FaireProductEntity = {
  token: "p_8uquc4add9",
  type: "product",
  name: "INITIALS PENDANT TRENDY LARIAT NECKLACE_CWAJE237",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/c5bee83a0d8e96ab7b27ac1280bfd701e3944c04422c1490b53a9b31005a145d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/37c99ecbdfc48465d2e22291b7796dbeb4c8ffbaf56f0aee37dbb6c5c28a26ad.jpeg",
    "https://cdn.faire.com/fastly/dc63835b1aa6a519459a222cb3c8260fe6c49361524840609e96ec28e598e6ec.jpeg",
    "https://cdn.faire.com/fastly/8c038609d297ffbf8fd91d76f05ed100efda81afc9f2cfb19c349329b13bddf8.jpeg",
    "https://cdn.faire.com/fastly/d04f3de724ef35a1f1dab5db4ed2a0510e0b483e1e5f20198c2f6abfc6489b76.jpeg",
    "https://cdn.faire.com/fastly/6b4eb81a5d77e79c49000f4cf2d8f06b487abc60437676fca54a37976092672d.jpeg",
    "https://cdn.faire.com/fastly/44f0f94c7c8e977e92a008b33759eb204e1f94285c91838eb9ccb7a6b3c48dbc.jpeg",
    "https://cdn.faire.com/fastly/d1943d64774f7ec2a1e2cd362bdf9ec4a1c064e0ac1467254746ac00e8d2f7f3.jpeg",
    "https://cdn.faire.com/fastly/6f430e3d6d52e6e6a4c8eaa6b47f80b131fee4e27ac0a1aebbf5956abdd8cda2.jpeg",
  ],
  priceDollars: 5.89,
  description: "Initials pendant trendy lariat necklace, \n\nCWAJE237",
  tags: [],
  msrpDollars: 11.78,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:48.364Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
